import { Injectable } from '@angular/core';
import { BaseHttpService } from '../shared-services/base-http.service';
import { Observable } from 'rxjs';
import { ClientRegistration } from '../../models/client-registration'; 
import { ApiUrlsConstant } from '../../../app-constant';
import { ResponseVm } from '../../models/response-vm';
import { DefaultTemplateVm } from '../../models/client-template';
import { CurrencyVm } from '../../models/currency-vm';
import { CountryVm } from '../../models/country-vm';
import { paymentTemplateVm } from '../../models/client-payment';

@Injectable({
  providedIn: 'root'
})
export class ClientService extends BaseHttpService {
  apiUrls: any = ApiUrlsConstant;

  getCountryList() {
    return this.get<CountryVm[]>(this.apiUrls.countryAPI);
  }

   getCurrencyList() {
     return this.get<CurrencyVm[]>(this.apiUrls.currencyAPI);
   }

  loadRegistrationTemplates(){
     return this.get<DefaultTemplateVm[]>(this.apiUrls.clientTemplateAPI);
  }

  saveClient(data: any): Observable<ResponseVm> {
      return this.post<ResponseVm>(this.apiUrls.saveClientAPI,data);
  
   }

   getPaymentTemplates(){
    return this.get<paymentTemplateVm[]>(this.apiUrls.clientPaymentTemplate);
 }
 saveClientPayment(data: any): Observable<ResponseVm> {
  return this.post<ResponseVm>(this.apiUrls.saveclientPayment,data);

}

}
